import useUtilStore from "@/data/util";
import { StoreEnum } from "@/enums";
import { IMaybe, IRevitalization } from "@/types";
import { ApiUrl } from "@/utils/ApiNames";
import { AppRequest } from "@/utils/AppRequest";
import AppLogger from "@/utils/Logger";
import { StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

export interface RevitalizationState {
  revitalizationById: IMaybe<IRevitalization[]>;
  rvQuery: string;
}

export interface RevitalizationStateActions {
  getRevitalizationById: (query: string) => void;
  setRvQuery: (rvQuery?: string) => void;
}

export const storeCreator: StateCreator<
  RevitalizationState & RevitalizationStateActions
> = (set) => ({
  revitalizations: null,
  revitalizationById: null,
  rvQuery: "",
  setRvQuery: (rvQuery) => {
    if (!rvQuery) return set({ rvQuery: "" });
    set({ rvQuery });
  },
  getRevitalizationById: async (query = "") => {
    const { setIsLoading } = useUtilStore.getState();

    try {
      setIsLoading(true);
      const resp = await AppRequest(`${ApiUrl.Revitalization}${query}`);
      set({ revitalizationById: resp.data || [] });
    } catch (error) {
      AppLogger.error(
        "Error on getRevitalizationById =>",
        error as Error
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  },
});

const useRevitalizationStore = createWithEqualityFn<
  RevitalizationState & RevitalizationStateActions
>(
  devtools(storeCreator, { name: StoreEnum.REVITALIZATION }) as StateCreator<
    RevitalizationState & RevitalizationStateActions
  >,
  shallow
);

export default useRevitalizationStore;
